export default __webpack_public_path__ + "static/media/tripple_arrow.e411ef51.svg";